import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material';
var MaterialModule = /** @class */ (function () {
    function MaterialModule(matIconRegistry, domSanitizer) {
        matIconRegistry.addSvgIconSet(domSanitizer.bypassSecurityTrustResourceUrl('./assets/mdi.svg')); // Or whatever path you placed mdi.svg at
    }
    return MaterialModule;
}());
export { MaterialModule };
